import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface TablePersistedEntry {
  sortField?: string | null;
  sortOrder?: number;
  pageSize?: number;
  visibleColumns?: Record<string, boolean>;
}

type TableStateShape = Record<string, TablePersistedEntry>;

const tableStateSlice = createSlice({
  name: "tableState",
  initialState: {} as TableStateShape,
  reducers: {
    setTableSort(
      state,
      action: PayloadAction<{
        tableKey: string;
        sortField: string | null | undefined;
        sortOrder: number | undefined;
      }>,
    ) {
      if (!state[action.payload.tableKey]) state[action.payload.tableKey] = {};
      state[action.payload.tableKey].sortField = action.payload.sortField;
      state[action.payload.tableKey].sortOrder = action.payload.sortOrder;
    },
    setTablePageSize(state, action: PayloadAction<{ tableKey: string; pageSize: number }>) {
      if (!state[action.payload.tableKey]) state[action.payload.tableKey] = {};
      state[action.payload.tableKey].pageSize = action.payload.pageSize;
    },
    setTableVisibleColumns(
      state,
      action: PayloadAction<{ tableKey: string; visibleColumns: Record<string, boolean> }>,
    ) {
      if (!state[action.payload.tableKey]) state[action.payload.tableKey] = {};
      state[action.payload.tableKey].visibleColumns = action.payload.visibleColumns;
    },
  },
});

export const { setTableSort, setTablePageSize, setTableVisibleColumns } = tableStateSlice.actions;
export const tableStateReducer = tableStateSlice.reducer;

export const selectTableState =
  (tableKey: string) =>
  (state: any): TablePersistedEntry | undefined =>
    state.tableState?.[tableKey];
